import { AxiosResponse } from 'axios'
import { UserModel } from '../../components/RateSet/Form/types/user'

const usersApi = http => ({
  getAll() {
    return http({
      method: 'get',
      url: '/users'
    })
  }
})

export interface UsersHttpModel {
  getAll: () => Promise<AxiosResponse<UserModel[]>>
}

export default usersApi
